/**
 * Fades and slides in page sections as they scroll into view.
 * Skips the header/footer groups and the hero (which already has its own
 * load-in animation) to avoid clashing with existing motion.
 */
function initScrollReveal() {
  const sections = document.querySelectorAll('.content-for-layout > .shopify-section');

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('scroll-reveal--visible');
          observer.unobserve(entry.target);
        }
      }
    },
    { threshold: 0.1, rootMargin: '0px 0px -10% 0px' }
  );

  for (const section of sections) {
    if (section.classList.contains('hero-wrapper')) continue;

    // Skip anything already visible on load — only animate sections that
    // actually scroll into view from off-screen afterward.
    const rect = section.getBoundingClientRect();
    const alreadyInView = rect.top < window.innerHeight && rect.bottom > 0;
    if (alreadyInView) continue;

    section.classList.add('scroll-reveal');
    observer.observe(section);
  }
}

if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollReveal);
  } else {
    initScrollReveal();
  }
}
